import { FirearmAssignmentLogService } from './firearm-assignment-log.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { FIREARM_ASSIGNMENT_LOG_TYPE, FirearmAssignmentLog } from 'assets-model';
import { Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export abstract class FirearmAssignmentLogResolverBase implements Resolve<FirearmAssignmentLog> {

  constructor(protected service: FirearmAssignmentLogService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<FirearmAssignmentLog> {
    const key: number = FIREARM_ASSIGNMENT_LOG_TYPE.entityDecorator.toKeyObjectFromRouteParams(route.params);
    return this.service.get(key);
  }
}



